// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{box-sizing:border-box}body{background:#f4f7fa;color:#333;font-family:\"Open Sans\",sans-serif;min-height:100%}#app-container,.loading-segment{height:100%}.ui.form .field{margin:0 0 2em}.ui.form .file-segment{text-align:center;margin-top:0}.ui.form .file-segment .ui.image{margin-bottom:20px}.ui.form .form-actions{margin-top:40px}.list-unstyled{list-style:none;margin:0;padding:0}.react-datepicker-popper{z-index:9999 !important}", ""]);
// Exports
module.exports = exports;
